export default __webpack_public_path__ + "static/media/Gambetta-Bold.5341fb53.woff";